import(/* webpackMode: "eager" */ "/Users/gwrunner/actions-runner/GHA-4-M4B/_work/FBO/FBO/Procom.Phoenix.Web/Phoenix/microapps/workflow-hub-v2/app/page.tsx");
